import { z } from "zod";
import { QUOTE_STATUSES } from "../constants.js";

/** Formulaire public de demande de prix. */
export const createQuoteRequestSchema = z.object({
  contactName: z.string().min(1).max(120),
  email: z.string().email(),
  phone: z.string().max(40).optional().or(z.literal("")),
  eventDate: z.coerce.date().optional(),
  eventType: z.string().max(80).optional().or(z.literal("")),
  guestEstimate: z.coerce.number().int().positive().max(100000).optional(),
  message: z.string().max(4000).optional().or(z.literal("")),
  // Honeypot anti-bot : doit rester vide.
  website: z.literal("").optional(),
});
export type CreateQuoteRequestInput = z.infer<typeof createQuoteRequestSchema>;

/** Mise à jour côté back-office. */
export const updateQuoteRequestSchema = z.object({
  status: z.enum(QUOTE_STATUSES).optional(),
  adminNotes: z.string().max(8000).optional(),
});
export type UpdateQuoteRequestInput = z.infer<typeof updateQuoteRequestSchema>;

/** Conversion d'un lead en compte client. */
export const convertQuoteRequestSchema = z.object({
  name: z.string().min(1).max(120),
  email: z.string().email(),
  mode: z.enum(["password", "invite"]),
  password: z.string().min(8).max(200).optional(),
});
export type ConvertQuoteRequestInput = z.infer<typeof convertQuoteRequestSchema>;
